import { css, cx } from '@eti/styles';
import { vars } from '@etg/wings';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const wingWrapperStyles = css`
  fill: ${vars.colors.inputs.border};
  height: 42px;
`;
const emptyRowStyles = css`
  height: 24px;
`;
const wingIcon = css`
  height: 60px;
  pointer-events: none;
  width: 30px;
`;
const LEFT_WING_VIEW_BOX = '0 0 64 128';
const RIGHT_WING_VIEW_BOX = '0 0 64 128';
const LEFT_WING_PATH_D = 'M0 32 V128 L64 96 V0 L0 32z';
const RIGHT_WING_PATH_D = 'M0 0 V96 L64 128 V32 L0 0z';
const LeftWing = () => /*#__PURE__*/_jsx("svg", {
  className: wingIcon,
  "data-testid": "leftWing",
  viewBox: LEFT_WING_VIEW_BOX,
  children: /*#__PURE__*/_jsx("path", {
    d: LEFT_WING_PATH_D
  })
});
const RightWing = () => /*#__PURE__*/_jsx("svg", {
  className: wingIcon,
  "data-testid": "rightWing",
  viewBox: RIGHT_WING_VIEW_BOX,
  children: /*#__PURE__*/_jsx("path", {
    d: RIGHT_WING_PATH_D
  })
});
const Wing = _ref => {
  let {
    isLeft,
    isRight,
    isEmptyRow
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: cx(wingWrapperStyles, isEmptyRow && emptyRowStyles),
    children: [isLeft && /*#__PURE__*/_jsx(LeftWing, {}), isRight && /*#__PURE__*/_jsx(RightWing, {})]
  });
};
export default Wing;
//# sourceMappingURL=Wing.js.map